import _ from 'lodash';

export const ADD_CLIP = 'ADD_CLIP';
export const MOVE_CLIP = 'MOVE_CLIP';
export const REMOVE_CLIP = 'REMOVE_CLIP';

export const SET_FEEDBACK_SAVED = 'SET_FEEDBACK_SAVED';
export const SET_FEEDBACK_SAVING = 'SET_FEEDBACK_SAVING';
export const SET_SAVING = 'SET_SAVING';
export const SET_TITLE = 'SET_TITLE';
export const SET_HIGHLIGHT_REEL = 'SET_HIGHLIGHT_REEL';
export const SET_MAXTIME_MODAL = 'SET_MAXTIME_MODAL';

export const OPEN_CLIP_MODAL = 'OPEN_CLIP_MODAL';
export const CLOSE_CLIP_MODAL = 'CLOSE_CLIP_MODAL';

const DEFAULT_TITLE = 'Untitled Highlight Reel';

const createClips = (clips) => _.orderBy(clips, 'clipOrder');
const createClipsMap = (clips) => _.keyBy(clips, (x) => x.testSessionNote.id);
const now = () => new Date().toISOString();

export const isClipsEqual = (clips, highlightReelClips) => {
  // Server-side clips
  const serverClips = _.chain(highlightReelClips)
    .map((clip) => ({
      testSessionNoteId: clip.testSessionNote.id,
      clipOrder: clip.clipOrder,
    }))
    .sortBy('clipOrder')
    .value();

  // Local clips
  const localClips = _.chain(clips)
    .map((clip) => ({
      testSessionNoteId: clip.testSessionNote.id,
      clipOrder: clip.clipOrder,
    }))
    .sortBy('clipOrder')
    .value();

  return _.isEqual(serverClips, localClips);
};

export const initialState = {
  clips: [],
  clipsMap: {},
  feedback: '',
  maxTimeModalOpened: false,
  touched: false,
  title: DEFAULT_TITLE,
  savedAt: now(),
  lastChange: null,
  showClipModal: false,
  selectedNoteId: null,
  highlightReel: {
    totalClips: 0,
    status: '',
    videoUrl: '',
  },
};

const reducer = (state, action) => {
  switch (action.type) {
    case ADD_CLIP: {
      const { clip } = action.payload;
      const { clipOrder } = clip;

      let clips = [...state.clips];
      clips.splice(clipOrder, 0, clip);

      clips = clips.map((clipValue, index) => ({
        ...clipValue,
        clipOrder: index,
      }));

      return {
        ...state,
        clips: createClips(clips),
        clipsMap: createClipsMap(clips),
        lastChange: now(),
      };
    }

    case REMOVE_CLIP: {
      const { index } = action.payload;
      let clips = [...state.clips];

      clips.splice(index, 1);

      clips = clips.map((clip, idx) => ({
        ...clip,
        clipOrder: idx,
      }));

      return {
        ...state,
        clips: createClips(clips),
        clipsMap: createClipsMap(clips),
        lastChange: now(),
      };
    }

    case MOVE_CLIP: {
      const { oldIndex, newIndex } = action.payload;
      let clips = [...state.clips];

      const moved = clips[oldIndex];
      clips.splice(oldIndex, 1);
      clips.splice(newIndex, 0, moved);

      clips = clips.map((clip, index) => ({
        ...clip,
        clipOrder: index,
      }));

      return {
        ...state,
        clips: createClips(clips),
        clipsMap: createClipsMap(clips),
        lastChange: now(),
      };
    }

    case SET_TITLE: {
      const { title } = action.payload;

      return {
        ...state,
        title,
        lastChange: now(),
      };
    }

    case SET_FEEDBACK_SAVING: {
      const { feedback, touched } = action.payload;

      return {
        ...state,
        feedback,
        touched,
      };
    }

    case SET_SAVING: {
      return {
        ...state,
        savedAt: now(),
      };
    }

    case SET_FEEDBACK_SAVED: {
      const { feedback, touched } = action.payload;

      return {
        ...state,
        feedback,
        touched,
      };
    }

    case SET_HIGHLIGHT_REEL: {
      const {
        highlightReel: {
          title,
          status,
          videoUrl,
          totalClips,
          highlightReelClips: clips,
        } = {},
      } = action.payload;

      const {
        status: currentStatus,
        savedAt,
        lastChange,
      } = state;

      let newState = {
        ...state,
      };

      // Only change videoUrl locally if the status of the video processing changes.
      // We are working with polling and VideoUrl is different on every call,
      // but the underlying video is not changing.
      // This happens because of URL auth signature.
      if (status !== currentStatus || totalClips === 0) {
        newState = {
          ...newState,
          videoUrl,
          status,
          totalClips,
        };
      }

      // In this case there was a local change after the last time we tried to save to the server
      // We should wait for our local change to try to save first
      if (lastChange > savedAt) {
        return newState;
      }

      newState = {
        ...newState,
        title,
        clips: createClips(clips),
        clipsMap: createClipsMap(clips),
      };

      return newState;
    }
    case SET_MAXTIME_MODAL: {
      const { maxTimeModalOpened } = action.payload;

      return {
        ...state,
        maxTimeModalOpened,
      };
    }
    case OPEN_CLIP_MODAL: {
      const { selectedNoteId } = action.payload;

      return {
        ...state,
        showClipModal: true,
        selectedNoteId,
      };
    }
    case CLOSE_CLIP_MODAL: {
      return {
        ...state,
        showClipModal: false,
        selectedNoteId: null,
      };
    }
    default:
      return state;
  }
};

// const reducerWithLogs = (state, action) => {
//   const newState = reducer(state, action);
//   console.log(action.type, action.payload, state, newState);
//   return newState;
// };

export default reducer;
